// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.src-components-ImagesListEditor-ImagesListEditor-module__box--gGT7G {
  display: flex;
  flex-direction: column;
  gap: 8px;
  border: none;
  background: none;
}
.src-components-ImagesListEditor-ImagesListEditor-module__box--gGT7G:focus {
  border: thin solid red;
  padding: 3px;
  border-radius: 4px;
}
.src-components-ImagesListEditor-ImagesListEditor-module__empty--SlwpK {
  color: gray;
  text-align: center;
}
.src-components-ImagesListEditor-ImagesListEditor-module__item--WRwKD {
  display: flex;
  padding: 2px 8px;
  align-items: center;
  border-radius: 4px;
  border: thin solid #d9d9d9;
}
.src-components-ImagesListEditor-ImagesListEditor-module__img--voYlL {
  width: 48px;
  height: 48px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.src-components-ImagesListEditor-ImagesListEditor-module__name--fvrIk {
  flex: 1;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 160%;
  text-align: left;
  margin-left: 8px;
}
.src-components-ImagesListEditor-ImagesListEditor-module__del--kyDQY {
  padding: 0;
}
/*# sourceMappingURL=ImagesListEditor.module.css.map */`, "",{"version":3,"sources":["webpack://./ImagesListEditor.module.less","webpack://./src/components/ImagesListEditor/ImagesListEditor.module.less"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,YAAA;EACA,gBAAA;ACCF;ADEE;EACE,sBAAA;EACA,YAAA;EACA,kBAAA;ACAJ;ADIA;EACE,WAAA;EACA,kBAAA;ACFF;ADKA;EACE,aAAA;EACA,gBAAA;EACA,mBAAA;EAEA,kBAAA;EACA,0BAAA;ACJF;ADOA;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;ACLF;ADQA;EACE,OAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;EAGA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,gBAAA;ACRF;ADWA;EACE,UAAA;ACTF;AACA,sDAAsD","sourcesContent":[".box {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  border: none;\n  background: none;\n\n  // В случае необходимости активировать поле, которое содержит ошибки\n  &:focus {\n    border: thin solid red;\n    padding: 3px;\n    border-radius: 4px;\n  }\n}\n\n.empty {\n  color: gray;\n  text-align: center;\n}\n\n.item {\n  display: flex;\n  padding: 2px 8px;\n  align-items: center;\n\n  border-radius: 4px;\n  border: thin solid #d9d9d9;\n}\n\n.img {\n  width: 48px;\n  height: 48px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.name {\n  flex: 1;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n\n  // color: #E43D00; Видимо, предполагалось, что это ссылка. Поэтому нет смысла явно указывать красный цвет.\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 160%;\n  text-align: left;\n  margin-left: 8px;\n}\n\n.del {\n  padding: 0;\n}\n",".box {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  border: none;\n  background: none;\n}\n.box:focus {\n  border: thin solid red;\n  padding: 3px;\n  border-radius: 4px;\n}\n.empty {\n  color: gray;\n  text-align: center;\n}\n.item {\n  display: flex;\n  padding: 2px 8px;\n  align-items: center;\n  border-radius: 4px;\n  border: thin solid #d9d9d9;\n}\n.img {\n  width: 48px;\n  height: 48px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.name {\n  flex: 1;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 160%;\n  text-align: left;\n  margin-left: 8px;\n}\n.del {\n  padding: 0;\n}\n/*# sourceMappingURL=ImagesListEditor.module.css.map */"],"sourceRoot":""}]);
// Exports
export var box = `src-components-ImagesListEditor-ImagesListEditor-module__box--gGT7G`;
export var empty = `src-components-ImagesListEditor-ImagesListEditor-module__empty--SlwpK`;
export var item = `src-components-ImagesListEditor-ImagesListEditor-module__item--WRwKD`;
export var img = `src-components-ImagesListEditor-ImagesListEditor-module__img--voYlL`;
export var name = `src-components-ImagesListEditor-ImagesListEditor-module__name--fvrIk`;
export var del = `src-components-ImagesListEditor-ImagesListEditor-module__del--kyDQY`;
export default ___CSS_LOADER_EXPORT___;
